export default function FormatDateTime(dateInput) {
    // Create a Date object from the input
    const date = new Date(dateInput);

    // Check if the date is valid
    if (isNaN(date)) {
        return 'Invalid Date';
    }

    // Define options for formatting
    const options = {
        weekday: 'long',
        day: 'numeric',
        month: 'long',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        hour12: true
    };

    // Get the day and create a formatted day with ordinal suffix
    const day = date.getDate();
    const dayWithSuffix = day + (day % 10 === 1 && day !== 11 ? "st" : (day % 10 === 2 && day !== 12 ? "nd" : (day % 10 === 3 && day !== 13 ? "rd" : "th")));

    // Format the date and replace the day with the dayWithSuffix
    const formattedDate = `${date.toLocaleDateString('en-US', options).replace(day, dayWithSuffix)}`;

    return formattedDate;
}